import { useMutation } from "@apollo/client";
import { EVENT_PDF_STANDS_QRCODE } from "graphql/mutation/event-gql";
import { successNotification, errorNotification } from "components/request-result";
import { saveAs } from "file-saver";


const useMutationEventPdfStadsQrCode = () => {

    function getFileNameFromUrl(url) {
        const value = url.split('/');
        return value[ value.length - 1 ];
    }

    const [ _setEventPdfStadsQrCode, { loading } ] = useMutation(EVENT_PDF_STANDS_QRCODE,
        {
            update(cache, { data }) {

                const {
                    eePdfStadsQrCode: {
                        label,
                        message,
                        file
                    }
                } = data;

                successNotification({
                    title: label,
                    description: message
                })


                saveAs(file, getFileNameFromUrl(file));
            },


            onError(error) {
                errorNotification(error);
            },

        }
    );


    return {
        _setEventPdfStadsQrCode,
        loadingMutationEventPdfStadsQrCode: loading,
    }
};


export default useMutationEventPdfStadsQrCode;

